import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ChangeDetectionStrategy,
    input,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'app-generic-trend',
    templateUrl: './generic-trend.component.html',
    styleUrl: './generic-trend.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent],
})
export class GenericTrendComponent implements OnInit, OnChanges {
    readonly genericTrendText = input<string>('network data');
    readonly inverted = input<boolean>(false);
    readonly numericDayValue = input<number>(0);
    readonly percentChange = input<number>();
    readonly showPrecision = input<boolean>(true);
    @Input() valueOne?: number;
    @Input() valueTwo?: number;

    result: number = 0;

    constructor() {}

    ngOnInit() {
        this.result = this.percentChange() ?? 0;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['percentChange']) {
            this.result = this.percentChange() ?? 0;
        }
    }

    calculatePercentage(valueOne: number, valueTwo: number) {
        return Math.abs(((valueTwo - valueOne) / valueOne) * 100).toFixed(2);
    }

    formatNumber(value: number) {
        if (!this.showPrecision()) {
            return Math.round(value).toLocaleString('en-US');
        }
        return value.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    formatPercent(percent: number) {
        return Math.abs(percent * 100).toFixed(0);
    }
}
